import { Link } from "react-router-dom";
import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { ASSETS, BUSINESS } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#013368] text-slate-100 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center">
                <img src={ASSETS.logo} alt="Il Velocipede" className="w-11 h-11 object-contain" />
              </div>
              <div>
                <div className="font-display font-extrabold text-lg">Il Velocipede</div>
                <div className="text-xs text-slate-300 uppercase tracking-widest">dal 1973</div>
              </div>
            </div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Storico rivenditore ufficiale Piaggio e Kymco a Roma. Officina specializzata per scooter, moto e biciclette nel quartiere Nuovo Salario.
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4 text-base">Servizi</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/scooter" className="text-slate-300 hover:text-white transition" data-testid="footer-link-scooter">Rivenditore Scooter</Link></li>
              <li><Link to="/officina-moto" className="text-slate-300 hover:text-white transition" data-testid="footer-link-officina-moto">Officina Moto e Scooter</Link></li>
              <li><Link to="/officina-bici" className="text-slate-300 hover:text-white transition" data-testid="footer-link-officina-bici">Officina Biciclette</Link></li>
              <li><Link to="/chi-siamo" className="text-slate-300 hover:text-white transition" data-testid="footer-link-chi-siamo">Chi Siamo</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4 text-base">Contatti</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#fd0100] shrink-0" /><span className="text-slate-300">{BUSINESS.address}<br/>{BUSINESS.city}</span></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#fd0100]" /><a href={`tel:${BUSINESS.phoneRaw}`} className="text-slate-300 hover:text-white" data-testid="footer-phone">{BUSINESS.phoneDisplay}</a></li>
              <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-[#fd0100]" /><a href={`https://wa.me/${BUSINESS.whatsappRaw}`} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white" data-testid="footer-whatsapp">{BUSINESS.whatsappDisplay}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-white mb-4 text-base flex items-center gap-2"><Clock className="w-4 h-4" /> Orari</h4>
            <ul className="space-y-1 text-sm text-slate-300">
              {BUSINESS.hours.map((row) => (
                <li key={row.d} className="flex justify-between gap-3">
                  <span>{row.d}</span>
                  <span className="text-slate-400 text-right">{row.h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Il Velocipede · P.IVA su richiesta · Tutti i diritti riservati</div>
          <div>Rivenditore ufficiale Piaggio · Kymco</div>
        </div>
      </div>
    </footer>
  );
}
